<script setup lang="ts">
import type { components } from "@/types/openapi.interfaces";

import Checkbox from "@/components/ui/Checkbox.vue";

defineProps<{
  isClaimingMissingPoints: boolean;
  lines: components["schemas"]["ReceiptLine"][];
}>();
</script>

<template>
  <ul role="list" class="flex flex-col">
    <li
      v-for="line in lines"
      :key="line.id"
      class="flex w-full items-center gap-3 border-b border-[#D8E1E7] py-2 lg:gap-4 lg:py-3"
    >
      <Checkbox v-if="isClaimingMissingPoints" name="missingPoints" :value="line.id" />

      <span
        v-if="!isClaimingMissingPoints"
        class="text-secondary block h-auto w-3 shrink-0 text-base font-medium lg:w-4 lg:text-lg"
      >
        {{ line.quantity }}
      </span>

      <span class="text-secondary w-full text-base font-medium lg:text-lg">
        {{ line.name }}
      </span>

      <span
        class="text-primary shrink-0 text-base font-semibold"
        :aria-label="
          line.loyalty_points === 0
            ? `Produit non éligible`
            : `Points gagnés : ${line.loyalty_points}`
        "
      >
        <template v-if="line.loyalty_points === 0">-</template>

        <template v-else>
          {{ `${line.loyalty_points} ${line.loyalty_points === 1 ? "pt" : "pts"}` }}
        </template>
      </span>
    </li>
  </ul>
</template>
